import { lazy } from 'react';
import retry from '../../utils/webpack/chunkRetry';
var ModuleLoaderLazy = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "discord" */
        './ModuleLoader');
    });
});
export default ModuleLoaderLazy;
//# sourceMappingURL=ModuleLoaderLazy.js.map